import { type UserSubscribeToEpaperNotificationModel, getEpaperListArchivedMagazines, getEpaperMagazineId, getEpaperVisibleMagazineList, subscribeToEpaperNotifications } from '@develop/ia-api-library'
import type { RouteLocation } from '#vue-router'

type NamedRoute = RouteLocation['name']

export const useEpaper = () => {
  const { userId, user } = storeToRefs(useUserStore())
  const route = useRoute()

  const isEpaperSubscribed = computed(() => !!user.value?.epaperSubscribed)

  const isEpaperRegisterSuccessPage = computed(() => (['epaper-registrierung-bestaetigt', 'epaper-en-register-success'] as NamedRoute[]).includes(route.name))
  const isEpaperRegisterPage = computed(() => (['epaper-registrierung', 'epaper-en-register'] as NamedRoute[]).includes(route.name))
  const isEpaperSubscribePage = computed(() => (['epaper-abonnieren', 'epaper-en-subscribe'] as NamedRoute[]).includes(route.name))
  const isEpaperSubscribeSuccessPage = computed(() => (['epaper-abonnieren-bestaetigt', 'epaper-en-subscribe-success'] as NamedRoute[]).includes(route.name))
  const isEpaperLandingPage = computed(() => (['epaper', 'epaper-en'] as NamedRoute[]).includes(route.name))
  const isEpaperLoginPage = (['epaper-login', 'epaper-en-login'] as NamedRoute[]).includes(route.name)

  const epaperUrl = computed(() => {
    if (isEpaperLandingPage.value) {
      return isEpaperSubscribed.value ? '/epaper/magazine' : (userId.value ? '/epaper/abonnieren' : '/epaper/registrierung')
    }
    return isEpaperSubscribed.value ? '/epaper/magazine' : '/epaper'
  })

  const getMagazinePages = async (magazineId: number) => {
    const magazine = await getEpaperMagazineId(magazineId)
    return magazine.data?.pages.map(page => ({ src: page })) || []
  }

  const getMagazineList = async () => {
    const response = await getEpaperVisibleMagazineList()
    return response.data ?? []
  }

  const getArchiveMagazineList = async (page: number) => {
    const response = await getEpaperListArchivedMagazines(page || 1)
    return response.data ?? []
  }

  const toggleEmailNotificationSubscription = async (subscribe: boolean) => {
    const response = await subscribeToEpaperNotifications({
      userId: userId.value,
      magazineTypeId: 1,
      notification: subscribe,
    } as UserSubscribeToEpaperNotificationModel)
    return response.data ?? []
  }

  return {
    epaperUrl,
    isEpaperLandingPage,
    isEpaperRegisterPage,
    isEpaperSubscribePage,
    isEpaperRegisterSuccessPage,
    isEpaperSubscribeSuccessPage,
    isEpaperSubscribed,
    isEpaperLoginPage,
    getMagazinePages,
    getMagazineList,
    getArchiveMagazineList,
    toggleEmailNotificationSubscription,
  }
}
